// import React, { useState } from 'react'
// import { Link, useNavigate } from 'react-router-dom'
// import axios from 'axios'

// import { toast } from 'react-toastify'
// const initialUser = { email: "", password:"", username:"" };


// const Registration = () => {
//   const navigate = useNavigate()
//     const [user, setUser] = useState(initialUser)

//  const handleUserChange = ({target}) => {
//     const{name,value} = target;
//     setUser((currentUser) => ({
//         ...currentUser,
//         [name] : value,
//     })) 
// }
//     const signUp =async () => {
    

//         try{
//         const url = `http://localhost:1337/api/auth/local/register`
//             if(user.username && user.email && user.password){
//                 const res= await axios.post(url, user);
//                 navigate("/login")
                
//                 console.log({res});
//             }
            
//         }catch(error){
//             console.log(error);
//             toast.error(error.message, {
//                 toastProgressBar: true,
//             })
//         }
//     }

    


//   return (
//     <div>
//       <form>
//         <input type="text" name='username' value={user.username} onChange={handleUserChange} placeholder='Enter your full name' />
//         <input type="email" name='email' value={user.email} onChange={handleUserChange} placeholder='Enter Your email' />
//         <input type="password" name='password' value={user.password} onChange={handleUserChange} placeholder='Enter Password' />
//         <button onClick={signUp}>SignUp</button>
//         <h6>Click<Link to="/login" >Here</Link> to Login</h6>

//       </form>
//     </div>
//   )
// }

// export default Registration
// Import necessary dependencies
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = 'http://localhost:1337'; // Change this to your Strapi API URL

const Registration = () => {
  const history = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`http://localhost:1337/api/auth/local/register`, {
        username: formData.username,
        email: formData.email,
        password: formData.password,
      });
      console.log('Registration successful:', response.data);
      history('/login'); // Redirect to login page after successful registration
    } catch (error) {
      console.error('Registration failed:', error);
    }
  };

  return (
    <div>
      <h2>Register</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" name="username" placeholder="Username" value={formData.username} onChange={handleChange} />
        <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} />
        <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} />
        <button type="submit">Register</button>
      </form>
    </div>
  );
};


export default Registration;
